import { faPlay } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ComponentProps } from 'preact';

import { useHabitatLiveStreamPlayerContext } from './contexts';

const HabitatLiveStreamPlayerPauseContent = (props: Omit<ComponentProps<'button'>, 'ref' | 'className'>) => {
  const { habitat } = useHabitatLiveStreamPlayerContext();
  const backgroundImage = habitat.offlineImage || habitat.wideImage;

  return (
    <button
      type="button"
      className="preflight preflight-button absolute inset-0 flex flex-col items-center justify-center bg-black p-2"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {backgroundImage && (
        <img
          src={backgroundImage}
          alt="background"
          className="preflight preflight-img absolute inset-0 size-full object-cover"
        />
      )}
      <div className="absolute inset-0 flex flex-col items-center justify-center bg-stone-900/55 p-5 desktop:p-10">
        <div className="flex w-full flex-col items-center gap-[21px] desktop:w-[220px] desktop:gap-[18px]">
          <FontAwesomeIcon icon={faPlay} className="text-[35px] desktop:text-[50px]" color="white" />
          <h2 className="preflight preflight-h2 w-full text-center text-xl font-bold leading-normal text-white desktop:text-[25px] desktop:leading-[26px]">
            Stream Paused
          </h2>
          <p className="preflight preflight-p w-full text-center text-base font-medium leading-normal text-white desktop:leading-[25px]">
            Click to Resume Playing
          </p>
        </div>
      </div>
    </button>
  );
};

export default HabitatLiveStreamPlayerPauseContent;
